


// storeLocalDB.js (updated)
const LOCAL_STORAGE_KEY = "savedStoresData";

export const getSavedDataFromLocalDB = () => {
  try {
    const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedData
      ? JSON.parse(savedData)
      : { storeCollections: {}, productCollections: {} };
  } catch (error) {
    return { storeCollections: {}, productCollections: {} };
  }
};

//-------------------- STORE COLLECTIONS --------------------//

export const saveStoreToCollection = (store, collectionName = "default") => {
  try {
    const savedData = getSavedDataFromLocalDB();
    const { storeCollections } = savedData;

    if (!storeCollections[collectionName]) {
      storeCollections[collectionName] = {
        name: collectionName,
        stores: [],
        createdAt: new Date().toISOString(),
      };
    }

    const exists = storeCollections[collectionName].stores.find(
      (s) => s.storeMobile === store.storeMobile
    );

    if (!exists) {
      storeCollections[collectionName].stores.push(store);
    }

    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({ ...savedData, storeCollections })
    );
    return true;
  } catch (error) {
    return false;
  }
};

export const removeStoreFromCollection = (storeMobile, collectionName = null) => {
  try {
    const savedData = getSavedDataFromLocalDB();
    const { storeCollections } = savedData;

    if (!collectionName) {
      Object.keys(storeCollections).forEach((name) => {
        storeCollections[name].stores = storeCollections[name].stores.filter(
          (s) => s.storeMobile !== storeMobile
        );

        if (storeCollections[name].stores.length === 0) {
          delete storeCollections[name];
        }
      });
    } else if (storeCollections[collectionName]) {
      storeCollections[collectionName].stores = storeCollections[collectionName].stores.filter(
        (s) => s.storeMobile !== storeMobile
      );

      if (storeCollections[collectionName].stores.length === 0) {
        delete storeCollections[collectionName];
      }
    }

    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({ ...savedData, storeCollections })
    );
    return true;
  } catch (error) {
    return false;
  }
};

export const getStoreCollections = () => Object.keys(getSavedDataFromLocalDB().storeCollections);

export const getCollectionsForStore = (storeMobile) => {
  const savedData = getSavedDataFromLocalDB();
  const matched = [];
  for (const name in savedData.storeCollections) {
    if (savedData.storeCollections[name].stores.some((s) => s.storeMobile === storeMobile)) {
      matched.push(name);
    }
  }
  return matched;
};

export const isStoreInAnyCollection = (storeMobile) => {
  return getCollectionsForStore(storeMobile).length > 0;
};

//-------------------- PRODUCT COLLECTIONS --------------------//

export const saveProductToCollection = (
  product,
  collectionName = "default"
) => {
  try {
    const savedData = getSavedDataFromLocalDB();
    const { productCollections } = savedData;

    if (!productCollections[collectionName]) {
      productCollections[collectionName] = {
        name: collectionName,
        products: [],
        createdAt: new Date().toISOString(),
      };
    }

    const productToSave = {
      ID: product.ID,
      ProductCode: product.ProductCode,
      BrandName: product.BrandName,
      ProductName: product.ProductName,
      Category: product.Category,
      Image1: product.Image1,
      Image2: product.Image2,
      Mrp: product.Mrp,
      OurPrice: product.OurPrice,
      Discount: product.Discount,
      Size: product.Size,
      Status: product.Status,
      StoreMobile: product.StoreMobile,
      StoreName: product.StoreName,
      Latitude: product.Latitude,
      Longitude: product.Longitude,
      AverageRating: product.AverageRating,
      Role: product.Role,
    };

    const existingIndex = productCollections[collectionName].products.findIndex(
      (p) => p.ID === productToSave.ID && p.StoreMobile === productToSave.StoreMobile
    );

    if (existingIndex >= 0) {
      productCollections[collectionName].products[existingIndex] = productToSave;
    } else {
      productCollections[collectionName].products.push(productToSave);
    }

    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({ ...savedData, productCollections })
    );
    return true;
  } catch (error) {
    return false;
  }
};

export const updateProductInCollection = (product, collectionName) => {
  return saveProductToCollection(product, collectionName);
};

export const removeProductFromCollection = (
  ID,
  StoreMobile,
  collectionName = null
) => {
  try {
    const savedData = getSavedDataFromLocalDB();
    const { productCollections } = savedData;

    if (!productCollections) {
      return false;
    }

    const removeFromCollection = (collection) => {
      const initialLength = collection.products.length;
      collection.products = collection.products.filter(
        (p) => !(p.ID === ID && p.StoreMobile === StoreMobile)
      );
      return initialLength !== collection.products.length;
    };

    if (!collectionName) {
      let removed = false;
      Object.keys(productCollections).forEach((name) => {
        if (removeFromCollection(productCollections[name])) {
          removed = true;
        }
        if (productCollections[name].products.length === 0) {
          delete productCollections[name];
        }
      });
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(savedData));
      return removed;
    } else if (productCollections[collectionName]) {
      const wasRemoved = removeFromCollection(productCollections[collectionName]);
      if (productCollections[collectionName].products.length === 0) {
        delete productCollections[collectionName];
      }
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(savedData));
      return wasRemoved;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const getProductCollections = () => Object.keys(getSavedDataFromLocalDB().productCollections);

export const getCollectionsForProduct = (ID, StoreMobile) => {
  const savedData = getSavedDataFromLocalDB();
  const matched = [];
  for (const name in savedData.productCollections) {
    if (
      savedData.productCollections[name].products.some(
        (p) => p.ID === ID && p.StoreMobile === StoreMobile
      )
    ) {
      matched.push(name);
    }
  }
  return matched;
};

export const isProductInAnyCollection = (ID, StoreMobile) => {
  const savedData = getSavedDataFromLocalDB();
  const productCollections = savedData.productCollections || {};

  return Object.values(productCollections).some((collection) =>
    collection.products.some(
      (product) => product.ID === ID && product.StoreMobile === StoreMobile
    )
  );
};

//-------------------- SUGGESTED COLLECTION NAMES --------------------//

export const getSuggestedCollections = (currentType = "store") => {
  const data = getSavedDataFromLocalDB();
  const oppositeType = currentType === "store" ? "productCollections" : "storeCollections";
  return Object.keys(data[oppositeType]);
};

//-------------------- COMMON COLLECTION FUNCTIONS --------------------//

export const getAllCollectionNames = () => {
  const savedData = getSavedDataFromLocalDB();
  const storeCollections = Object.keys(savedData.storeCollections || {});
  const productCollections = Object.keys(savedData.productCollections || {});
  const allCollections = new Set([...storeCollections, ...productCollections]);
  return Array.from(allCollections);
};

export const createCollection = (name, type = "store") => {
  if (!name.trim()) return false;

  const savedData = getSavedDataFromLocalDB();
  
  if (!savedData.storeCollections) {
    savedData.storeCollections = {};
  }
  if (!savedData.productCollections) {
    savedData.productCollections = {};
  }

  const collectionKey = type === "store" ? "storeCollections" : "productCollections";

  if (savedData[collectionKey][name]) {
    return false;
  }

  savedData[collectionKey][name] = {
    name,
    [type === "store" ? "stores" : "products"]: [],
    createdAt: new Date().toISOString(),
  };

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(savedData));
  return true;
};

export const getProductFromCollection = (
  ID,
  StoreMobile,
  collectionName
) => {
  try {
    const savedData = getSavedDataFromLocalDB();
    if (!savedData.productCollections[collectionName]) return null;

    return (
      savedData.productCollections[collectionName].products.find(
        (p) => p.ID === ID && p.StoreMobile === StoreMobile
      ) || null
    );
  } catch (error) {
    return null;
  }
};









